// extracted by mini-css-extract-plugin
export default {"dietPicker":"dietPicker_dietPicker__ta0as","dietPicker__footer":"dietPicker_dietPicker__footer__bkNNW"};